import {LinkCard} from "@/components/cards";
import {twMerge} from "tailwind-merge";
import {IMAGE_URL, LOCAL_IMAGE_URL} from "@/constants/general-constants";

export default function HowLinks({grid = false, parentClasses = "", contactClasses = ""}) {
    return (
        <div className={`${grid ? "grid grid-cols-1 gap-y-5" : "flex flex-col lg:flex-row justify-between lg:gap-x-5 gap-y-3.5 lg:gap-y-0"} ${parentClasses}`}>
            <LinkCard url="/contact-us" parentClasses={twMerge("lg:basis-[38%] min-h-[6.75rem]", contactClasses)} style={{backgroundImage: `url('${LOCAL_IMAGE_URL+"coffee-bg.webp"}')`}}
                      overLayProps={{style: {background: "linear-gradient(135deg, rgba(252,250,255,0.95) 25%, rgba(252,250,255,0.69) 100%)"}}}>
                <p className="text-left text-pol-dark font-bold">
                    <span>تماس با ما</span>
                    <i className="icon-simple-arrow-left mr-2.5 text-pol-orange-dark text-xs" />
                </p>
            </LinkCard>
            <LinkCard url="/how#freelancer-guide" parentClasses="lg:basis-[28%] min-h-[6.75rem]" style={{backgroundImage: `url('${LOCAL_IMAGE_URL+"notebook-bg.webp"}')`}}
                      overLayProps={{style: {background: "linear-gradient(135deg, rgba(26,23,34,0.96) 25%, rgba(50,46,62,0.87) 100%)"}}}>
                <p className="text-left text-pol-blue-light font-bold">
                    <span>برو به راهنمای فریلنسر</span>
                    <i className="icon-simple-arrow-left mr-2.5 text-pol-orange-dark text-xs" />
                </p>
            </LinkCard>
            <LinkCard url="/how#employer-guide" parentClasses="lg:basis-[34%] min-h-[6.75rem]" style={{backgroundImage: `url('${LOCAL_IMAGE_URL+"laptop-bg.webp"}')`}}
                      overLayProps={{style: {background: "linear-gradient(135deg, rgba(59,24,183,0.96) 25%, rgba(100,29,255,0.87) 100%)"}}}>
                <p className="text-left text-pol-blue-light font-bold">
                    <span>برو به راهنمای کارفرما</span>
                    <i className="icon-simple-arrow-left mr-2.5 text-pol-orange-dark text-xs" />
                </p>
            </LinkCard>
        </div>
    )
}
